import { Card, CardBody, Typography } from "@material-tailwind/react";
import Logo from "../../components/common/Logo";
import { FaCheckCircle } from "react-icons/fa";
import BaseButton from "../../components/common/buttons/BaseButton";
import { Link } from "react-router-dom";

function VerificationSuccessful() {
  return (
    <div className="md:flex w-screen md:h-screen bg-gray-50">
      <div className="invisible md:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
        <div className="absolute md:top-10 md:left-20">
          <Logo />
        </div>
        <div className="text-4xl">
          <h1>It’s easier to get</h1>
          <h2 className="inline">started with{` `}</h2>
          <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
        </div>
      </div>

      <div className="ml-20 md:hidden">
        <Logo />
      </div>
      <div className="flex items-center justify-center ">
        <Card
          placeholder={undefined}
          className="md:m-24 m-5 lg:m-36 rounded-md text-center"
        >
          <CardBody placeholder={undefined}>
            <div className="flex items-center justify-center">
              <FaCheckCircle size={32} color="black" />
            </div>
            <Typography placeholder={undefined}>
              Email Verification Successful
            </Typography>
            <Link replace to="/signIn">
              <BaseButton>Continue</BaseButton>
            </Link>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default VerificationSuccessful;
